import { render, staticRenderFns } from "./Shorten.vue?vue&type=template&id=d85a5e52&"
import script from "./Shorten.vue?vue&type=script&lang=js&"
export * from "./Shorten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports